module.exports = __webpack_public_path__ + "img/food-app.4fb86a95.webp";